import React, { useState, useRef } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import LoginWithPassWord from "./LoginWithPassWord";
import LoginMpinPassWord from "./LoginMpinPassWord";
import ForgotMpinOtp from "./ForgotMpinOtp";
// import HomePage from '../../HomePage/HomePage';
import { Link, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useDispatch } from "react-redux";
import {
  loginStart,
  loginFailure,
  loginSuccess,
} from "../../redux/userReducer";
import { TextField } from "@mui/material";

export default function LoginWithMpin({ studentDetails, setLogin }) {
  // const [mpin, setMpin] = useState("");
  const [showMpin, setShowMpin] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  const [loginWithMpin, setLoginWithMin] = useState({
    loginInstedPass: false,
    backArrow: false,
    forgotMpin: false,
    loginSucess: false,
  });
  const [mpin, setMpin] = useState(Array(6).fill("")); // 6 empty boxes

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputsRef = useRef([]);
  const schoolCode = localStorage.getItem("schoolCode");

  const handleMpinChange = (event) => {
    const { value } = event.target;
    // Only allow numbers in the MPIN input and restrict to 4 characters
    if (/^\d*$/.test(value) && value.length <= 6) {
      setMpin(value);
    }
  };
  const toggleShowMpin = () => {
    setShowMpin(!showMpin);
  };

  const handleChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, ""); // only digits
    if (!val) return;

    const newMpin = [...mpin];
    newMpin[i] = val.slice(-1); // only last digit
    setMpin(newMpin);

    // Move focus to next box automatically
    if (i < 5 && val) {
      inputsRef.current[i + 1].focus();
    }
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...mpin];

      if (mpin[i]) {
        // Case 1: current box has a digit → clear it
        newMpin[i] = "";
        setMpin(newMpin);
      } else if (i > 0) {
        // Case 2: current box is empty → move to previous box and clear it
        inputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setMpin(newMpin);
      }
      e.preventDefault(); // stop default backspace behavior (cursor movement)
    }
  };


  const handleLogin = async () => {
    setIsInProgress(true);
    dispatch(loginStart());


    try {
      let res = await axios.post(`/studentAuth/loginWithMpin`, {
        unique_id: studentDetails?.addmissionNumber,
        mpin: mpin.join(""),
        school_code: schoolCode,
      });

      res && dispatch(loginSuccess(res.data.data));
      if (res) {
        localStorage.setItem(
          "School_id",
          JSON.stringify(res?.data?.data?.addmission_no)
        );
        localStorage.setItem(
          "AuthToken",
          JSON.stringify(res.data?.data?.accessToken)
        );
      }
      // window.location.replace("/HomePage");
      navigate("/loginSuccessful");
    } catch (error) {
      dispatch(loginFailure());
      setErrorMessage(error.response.data.message);
      setIsInProgress(false);
      console.log(error);
    }
  };

  // const handleSendOtp = async () => {
  //   try {
  //     let res = await axios.post(`/studentAuth/generateEmailOtp`, {
  //       email_id: studentDetails?.email,
  //     });
  //     res &&
  // setLoginWithMin({
  //   ...loginWithMpin,
  //   forgotMpin: true,
  // });
  //   } catch (error) {
  //     setErrorMessage("Something went wrong!!!");
  //     console.log(error);
  //   }
  // };

  return (
    <div>
      {!loginWithMpin.loginInstedPass &&
        !loginWithMpin.backArrow &&
        !loginWithMpin.forgotMpin &&
        !loginWithMpin.loginSucess && (
          <div className="ContainerRegister h-100">
            <div className="row">
              <div className="col-md-3 p-0 bannerContainer">
                <img
                  className="bannerImg"
                  alt="icon"
                  src="/LoginRegister/BannerImg.png"
                ></img>
              </div>
              <div className="col-md-9 RegisterDetailContainer">
                <>
                  <div
                    className="backLoginIcon"
                    onClick={(e) =>
                      setLogin((prev) => ({
                        ...prev,
                        mpinLogin: false,
                        passwordLogin: false,
                      }))
                    }
                  >
                    <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                  </div>
                  <div className="InsideDetailCpntainer">
                    <div className="d-flex justify-content-center">
                      <img
                        className="registrationIcon"
                        src="/StudentImg/BreathSchoolLogo.svg"
                        alt="icon"
                      />
                    </div>
                    <div className="d-flex justify-content-center headerRegistration mt-3">
                      {/* Hello! {studentDetails?.name} */}
                      Welcome back!
                    </div>
                    <div className="UnlockFaceIdText d-flex justify-content-center mt-2 ">
                      Login with PIN
                    </div>
                    <div className="d-flex justify-content-between align-items-center  mt-4">
                      {/* <input
                        type="text"
                        className="otpInput"
                        readOnly="true"
                        value={studentDetails?.addmissionNumber}
                      /> */}
                      <TextField
                        id="outlined-read-only-input"
                        label="Login ID"
                        className="registrationMPinInput"
                        readOnly="true"
                        value={studentDetails?.addmissionNumber}
                        slotProps={{
                          input: {
                            readOnly: true,
                          },
                        }}
                      />

                    </div>
                    <div
                      style={{ borderColor: errorMessage && "#D40D12" }}
                      className="d-flex justify-content-between align-items-center registrationInput-pin mt-4"
                    >
                      {/* <input
                        type={showMpin ? "text" : "password"}
                        id="mpin"
                        className="otpInput"
                        name="mpin"
                        placeholder="Enter Pin"
                        value={mpin}
                        onChange={handleMpinChange}
                        required
                        maxLength={4}
                      /> */}
                      {/* <TextField
                        label="Enter Pin"
                        variant="outlined"
                        type={showMpin ? "text" : "password"}
                        id="mpin"
                        className="registrationInput mr-1"
                        name="mpin"
                        value={mpin}
                        onChange={handleMpinChange}
                        required
                        maxLength={6}
                      /> */}
                      {mpin?.map((val, i) => (
                        <input
                          key={i}
                          ref={(el) => (inputsRef.current[i] = el)}
                          type={showMpin ? "text" : "password"}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength={1}
                          value={val}
                          placeholder="_"
                          onChange={(e) => handleChange(e, i)}
                          onKeyDown={(e) => handleKeyDown(e, i)}
                          style={{
                            width: 44,
                            height: 52,
                            textAlign: "center",
                            fontSize: 24,
                            border: "1px solid #ccc",
                            borderRadius: 8,
                          }}
                        />
                      ))}

                      {errorMessage ? (
                        <span
                          style={{ color: "#D40D12" }}
                          className="align-self-center w-25"
                        >
                          PIN error!
                        </span>
                      ) : (
                        <span onClick={toggleShowMpin}>
                          {showMpin ? <FiEye /> : <FiEyeOff />}
                        </span>
                      )}
                    </div>

                    <div className="d-flex flex-column justify-content-center mt-4">
                      <button
                        type="submit"
                        disabled={mpin === "" || isInProgress}
                        className="RegisterBtn"
                        onClick={handleLogin}
                      >
                        Login
                      </button>
                    </div>

                    <div
                      className="skipfacetext d-flex justify-content-center mt-3"
                      onClick={() =>
                        setLoginWithMin({
                          ...loginWithMpin,
                          forgotMpin: true,
                        })
                      }
                    >
                      Forgot PIN?
                    </div>
                    <div className="d-flex justify-content-center mt-5">
                      <div
                        className="loginpasswordInstead mt-5"
                        onClick={(e) => {
                          setLoginWithMin({
                            ...loginWithMpin,
                            loginInstedPass: true,
                          });
                        }}
                      >
                        Login with Password instead{" "}
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
      {loginWithMpin.loginInstedPass && (
        <LoginWithPassWord studentDetails={studentDetails} />
      )}
      {loginWithMpin.backArrow && (
        <LoginMpinPassWord studentDetails={studentDetails} />
      )}
      {loginWithMpin.forgotMpin && (
        <ForgotMpinOtp studentDetails={studentDetails} />
      )}
      {/* {loginWithMpin.loginSucess && <HomePage />} */}
    </div>
  );
}
